import { TF } from 'react-translator-component';

import { attemptStatusLabel } from './doorAccessMapping';
import { AttemptText } from './styled';

import { DoorAttemptResult } from '../../../../types/responses/DoorAccess';

export interface DoorAttempt {
  kind: 'test' | 'open';
  result?: DoorAttemptResult;
  error?: string;
}

const describe = (
  attempt: DoorAttempt,
): { tone: 'success' | 'error'; title: string; sub: string | null } => {
  const isTest = attempt.kind === 'test';

  if (!attempt.result) {
    const failure = TF('Request failed');
    return {
      tone: 'error',
      title: isTest
        ? TF('Test failed: {0}', failure)
        : TF('Opening failed: {0}', failure),
      sub: attempt.error ?? null,
    };
  }

  const { status, httpStatus, durationMs, message } = attempt.result;
  const label = attemptStatusLabel(status, httpStatus);

  if (status === 'SUCCESS') {
    return {
      tone: 'success',
      title: isTest
        ? TF('Test sent: {0}', label)
        : TF('Door opened: {0}', label),
      sub:
        durationMs == null
          ? null
          : isTest
          ? TF('Connection checked in {0} ms.', durationMs)
          : TF('Synchronous call completed in {0} ms.', durationMs),
    };
  }

  return {
    tone: 'error',
    title: isTest
      ? TF('Test failed: {0}', label)
      : TF('Opening failed: {0}', label),
    sub: message ? TF(message) : null,
  };
};

interface DoorAttemptBoxProps {
  attempt: DoorAttempt | null;
}

const DoorAttemptBox = ({ attempt }: DoorAttemptBoxProps) => {
  if (!attempt) return null;

  const { tone, title, sub } = describe(attempt);

  return (
    <AttemptText $tone={tone}>
      <span className='dot' />
      {title}
      {sub && <span className='sub'>· {sub}</span>}
    </AttemptText>
  );
};

export default DoorAttemptBox;
